import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Empty } from "antd";
import {
  Actions,
  Container,
  NoData,
  SaveBtn,
  DeleteBtn,
  Wrapper,
} from "./style";
import { workConstructor } from "./../../../utils/workConstructor";
import Spinner from "../../../components/Spinner";
import works from "../../../services/works";
import TaskCard from "../../../components/Cards/TaskCard";
import MultipleSelect from "../../../components/FormElements/MultipleSelect";
import { useHideModal, useShowAlert, useShowModal } from "../../../hooks";
import { setTotal } from "../../../redux/modules/works/actions";
import Confirm from "../../../components/Confirm";
import objects from "../../../services/objects";
import { setSingleDate } from "../../../redux/modules/dates/actions";
import moment from "moment";
import Player from "../../../components/Player";
import MultiDatePicker from "../../../components/FormElements/MultiDatePicker";
import { MdOutlineVideoLibrary } from "react-icons/md";

export default () => {
  const { error, success } = useShowAlert();
  const { groupId, regionId } = useSelector((state) => state.authReducer);
  const { categories, regions, groups, users } = useSelector(
    (state) => state.appReducer
  );
  const { showBlured } = useShowModal();
  const { hideModal } = useHideModal();
  const dispatch = useDispatch();
  const { singleDate } = useSelector((state) => state.selectedDateReducer);
  const { constructorMethod } = workConstructor();
  const provinceId = localStorage.getItem("provinceId");
  const [loading, setLoading] = useState(true);
  const [objectsList, setObjectsList] = useState([]);
  const [fieldError, setFieldError] = useState(false);
  const [worksData, setWorksData] = useState([]);
  const [desc, setDesc] = useState("");
  const [sound, setSound] = useState("");
  const [object, setObject] = useState([]);
  const [determinedDays, setDeterminedDays] = useState([]);

  const fetchWorks = () => {
    const common = { categories, regions, groups, users };
    const postData = {
      date: moment(singleDate).format("YYYY-MM-DD"),
      province: provinceId,
      region: regionId,
      group: groupId,
      page: 1,
      limit: 1,
      status: 1,
    };

    const totalsData = {
      date: moment(singleDate).format("YYYY-MM-DD"),
      region: regionId,
      group: groupId,
    };
    const determinedData = {
      date: moment().format("YYYY-MM-DD"),
      status: 1,
      group: groupId,
      region: regionId,
    };
    works
      .getWorkDays(determinedData)
      .then((res) => {
        setDeterminedDays(res);
      })
      .catch((err) => console.error(err));
    works
      .getTotal(totalsData)
      .then(({ newWorks }) => {
        if (Object.keys(newWorks).length > 0) {
          dispatch(setTotal(newWorks?.count));
        } else {
          dispatch(setTotal(0));
        }
      })
      .catch((error) => {
        dispatch(setTotal(0));
        console.error(error);
      });
    works
      .getNewWorksSecretary(postData)
      .then(({ docs }) => {
        const workerData = constructorMethod(docs, common);
        setWorksData(workerData);
        setDesc(workerData[0]?.desc ?? "");
        setSound(workerData[0]?.sound ?? "");
        if (workerData[0]?.objects[0]?._id) {
          setObject((prev) => [workerData[0]?.objects[0]?._id]);
        } else {
          setObject(["empty"]);
        }
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  };
  useEffect(() => {
    setLoading(true);
    fetchWorks();
  }, [singleDate, categories, regions, groups, users]);
  useEffect(() => {
    if (worksData?.length > 0 && worksData[0]?.object) {
      const objId = categories?.find(
        (item) => item._id === worksData[0]?.subCategory
      )?.object;
      if (objId) {
        const data = {
          parent: objId,
          region: worksData[0]?.region,
          limit: 1000,
          page: 1,
        };
        objects
          .getAllSubsListByParentId(data)
          .then((resp) => {
            setObjectsList(resp?.docs);
          })
          // .finally(() => setLoading(false))
          .catch((err) => console.error(err));
      }
    }
    if (worksData?.length > 0) {
      setSound(worksData[0]?.sound);
    }
  }, [worksData]);

  const handleDescription = (input) => {
    const { value } = input.target;
    setDesc(value);
  };

  const handleDeleteImage = (image) => {
    if (Object.keys(image).length > 0) {
      setLoading(true);
      const data = {
        id: image._id,
      };
      works
        .deleteImage(data)
        .then(() => {
          fetchWorks();
        })
        .catch((err) => console.error(err))
        .finally(() => setLoading(false));
      hideModal();
    }
  };
  const handleSelectObject = (input) => {
    setObject([input]);
  };

  const handleUpdateWork = () => {
    const objectError =
      worksData[0]?.object != null ? object.length > 0 && true : true;
    if (desc?.trim()?.length > 4 && objectError) {
      setLoading(!loading);
      setFieldError(false);
      const id = worksData[0]._id;
      const {
        categoryName,
        regionName,
        groupName,
        subCategoryName,
        userName,
        ...rest
      } = worksData[0];
      const putData = {
        ...rest,
        desc: desc.trim(),
        status: 1,
        objects: object[0] !== "empty" ? object : [],
        media: worksData[0].media,
        sound: "",
      };
      works
        .update(id, putData)
        .then(() => {
          fetchWorks();
          success("Мувофаққиятли юборилди!", 2, "bottom");
          setObject([]);
        })
        .catch((err) => console.error(err))
        .finally(() => {
          setLoading(false);
        });
    } else {
      error(
        `Изоҳлар ${
          worksData[0].object ? "ва объектни танлаш" : ""
        } майдони бўш бўлмаслиги лозим!`,
        2,
        "topRight"
      );
      setFieldError(true);
    }
  };
  const deleteWork = (id) => {
    setLoading(true);
    const data = {
      id,
    };
    if (!worksData[0]?.media.length) {
      works
        .deleteWork(id)
        .then(() => fetchWorks())
        .catch((err) => {
          error("Маълумотни олиб ташлашда хатолик юз берди!", 2, "topRight"),
            console.error(err);
        })
        .finally(() => setLoading(false));
    }
    if (worksData[0]?.media.length > 0) {
      works
        .delete(data)
        .then(() => fetchWorks())
        .catch((err) => {
          error("Маълумотни олиб ташлашда хатолик юз берди!", 2, "topRight"),
            console.error(err);
        })
        .finally(() => setLoading(false));
    }
    hideModal();
  };
  const handleDeleteWork = (id) => {
    showBlured({
      title: "Ўчириб ташлаш!",
      maxWidth: "400px",
      height: "400px",
      withHeader: false,
      body: () => <Confirm agree={() => deleteWork(id)} cancel={hideModal} />,
    });
  };
  const deleteSound = () => {
    const newValues = [...worksData];
    newValues[0].sound = "";
    setWorksData(newValues);
  };

  const handleChangeDateInput = (date) => {
    dispatch(setSingleDate(moment(date).format("YYYY-MM-DD")));
  };

  if (loading) return <Spinner maxHeight="100%" />;
  return (
    <Wrapper>
      <div
        style={{
          alignSelf: "flex-end",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <div style={{ width: "150px" }}>
          <MultiDatePicker
            dates={determinedDays}
            onChange={handleChangeDateInput}
            startDate={moment(singleDate)?._d}
          />
        </div>
      </div>
      {worksData?.length > 0 ? (
        <Container>
          <div className="work">
            <TaskCard
              canDeleteImage
              data={worksData[0]}
              description={desc}
              handleDescription={handleDescription}
              handleDeleteImage={handleDeleteImage}
              errorHelper={desc && desc?.length < 70 && true}
              allowEdit
            />
          </div>
          <Actions>
            <div className="actions-block">
              <DeleteBtn onClick={() => handleDeleteWork(worksData[0]?._id)}>
                Ўчириш
              </DeleteBtn>
              {sound && <Player url={sound} deleteSound={deleteSound} />}
              <div id="selects">
                {worksData[0]?.object && (
                  <div id="object-select">
                    <div id="title">Тадбир ўтказилган жой</div>
                    <MultipleSelect
                      status={!object[0] && "error"}
                      errorHelper={fieldError}
                      onChange={handleSelectObject}
                      id={worksData[0]?._id}
                      data={objectsList}
                      placeholder=""
                      defaultVal={
                        worksData[0]?.objects && worksData[0]?.objects[0]?._id
                      }
                    />
                  </div>
                )}

                <SaveBtn
                  isDisabled={
                    desc &&
                    desc?.length > 69 &&
                    (object[0] === "empty" || object.length > 0)
                  }
                  disabled={
                    !(
                      desc &&
                      desc?.length > 69 &&
                      (object[0] === "empty" || object.length > 0)
                    )
                  }
                  onClick={handleUpdateWork}
                >
                  Юбориш
                </SaveBtn>
              </div>
            </div>
          </Actions>
        </Container>
      ) : (
        <Container>
          <NoData>
            <Empty
              description={
                <h1>Белгиланган кун учун қилинган ишлар топилмади!</h1>
              }
            />
          </NoData>
        </Container>
      )}
    </Wrapper>
  );
};
